import React, { useState } from 'react';
import EnterPriseDevelopment from './EnterPriseDevelopment';

const TraningCourse = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => setIsOpen(!isOpen);
    const [selected, setSelected] = useState('Candidate');

    const options = ['R123456789 ', 'Individual', 'Community', 'Cooperative'];
    return (
        <div className='md:px-24 px-4'>
            <h1 className='md:text-[28px] text-[10px] font-bold text-[#03897B] mb-3'>SERVICES</h1>
            {/* Grid Section */}
            <div className="w-full grid grid-cols-4 sm:grid-cols-2 lg:grid-cols-4 gap-2">
                <div className="bg-[#152C24] w-full md:h-[53px] h-[30px] flex items-center justify-between rounded-md px-2 md:px-4">
                    <span className="text-white text-[5px] sm:text-[18px] font-bold">MOBI-COACH</span>
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746301721/image_1636_exrkju.png"
                        alt="Logo"
                        className="w-[18px] sm:w-[81px] h-[8px] sm:h-[42px] object-contain"
                    />
                </div>

                <div className="bg-[#152C24] w-full md:h-[53px] h-[30px] flex items-center justify-between rounded-md px-2 md:px-4">
                    <span className="text-white text-[6px] md:ml-14 sm:text-[18px] font-bold">ACE</span>
                    <div className="w-[20px] sm:w-[81px] h-[10px] sm:h-[42px] bg-gray-300 rounded" />
                </div>

                <div className="bg-[#152C24] w-full h-[30px] md:h-[53px] flex items-center justify-between rounded-md px-2 md:px-4">
                    <span className="text-white text-[6px] md:ml-14 sm:text-[18px] font-bold">AFS</span>
                    <div className="w-[20px] sm:w-[81px] h-[10px] sm:h-[42px] bg-gray-300 rounded" />
                </div>

                <div className="bg-[#152C24] w-full h-[30px] md:h-[53px] flex items-center justify-between rounded-md px-2 md:px-4">
                    <span className="text-white text-[6px] md:ml-14 sm:text-[18px] font-bold">-</span>
                    <div className="w-[20px] sm:w-[81px] h-[10px] sm:h-[42px] bg-gray-300 rounded" />
                </div>
            </div>

            {/* Text Section */}
            <div className="mt-6">
                <div className="flex sm:flex-row justify-between items-center gap-2">
                    <h1 className="text-[10px] sm:text-[28px] font-bold text-[#03897B]">MOBI-COACH</h1>
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746301721/image_1636_exrkju.png"
                        alt="hi"
                        className="w-[40px] sm:w-[81px] h-[15px] sm:h-[42px] object-contain"
                    />
                </div>
                <p className="text-[8px] sm:text-[24px] font-normal mt-3">
                    Ad-Luck MobiCoach is a digital training platform designed to assess the needs of farmers and entrepreneurs, and deliver tailored training programs accessible via mobile phones. In addition to digital access, the platform also offers in-person training to ensure inclusive and practical learning experiences.
                </p>
            </div>

            {/* Buttons Section */}
            <div className="flex items-center space-x-[2px]  md:space-x-4 md:space-y-0">
                {/* Evaluation Button */}
                <div className="flex items-center ml-auto pr-2 md:pr-0 md:mb-1">
                    <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[4px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                        Evaluation
                    </p>
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                        alt="Expand"
                        className="w-[15px] h-[17px] md:h-[55px] md:w-[40px] object-contain md:rounded-tr-[5px] rounded-tr-md font-bold rounded-br-[5px] bg-[#F38323] md:px-2  px-1  md:py-1"
                    />
                </div>

                {/* Training Course Button */}
                <a href='/TrainingCourse'>
                    <div className="flex items-center ml-auto pr-2 md:pr-0 md:mb-1">
                        <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[4px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                            Training course
                        </p>
                        <img
                            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                            alt="Expand"
                            className="w-[15px] h-[17px] md:h-[55px] md:w-[40px] object-contain md:rounded-tr-[5px] rounded-tr-md font-bold rounded-br-[5px] bg-[#F38323] md:px-2  px-1  md:py-1"
                        />
                    </div>
                </a>

                {/* Certification Button */}
                <div className="flex items-center ml-auto pr-2 md:pr-0 md:mb-1">
                    <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[4px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                        Certification
                    </p>
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                        alt="Expand"
                        className="w-[15px] h-[17px] md:h-[55px] md:w-[40px] object-contain md:rounded-tr-[5px] rounded-tr-md font-bold rounded-br-[5px] bg-[#F38323] md:px-2  px-1  md:py-1"
                    />
                </div>

                {/* Reviews Button */}
                <a href='/Review'>
                    <div className="flex items-center ml-auto pr-2 md:pr-0 md:mb-1">
                        <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[4px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                            Reviews
                        </p>
                        <img
                            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                            alt="Expand"
                            className="w-[15px] h-[17px] md:h-[55px] md:w-[40px] object-contain md:rounded-tr-[5px] rounded-tr-md font-bold rounded-br-[5px] bg-[#F38323] md:px-2  px-1  md:py-1"
                        />
                    </div>
                </a>

                <div>
                    {/* Registration Number Section */}
                    <div className="flex items-center ml-auto pr-2 md:pr-0 md:mb-1 mt-3 md:mt-8 relative">
                        <p className="md:text-[28px] text-[4px] bg-[#03897B] text-white px-2 md:px-4 md:w-[300px] md:h-[55px] md:py-[10px] py-[5px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                            R123456789
                        </p>
                        <img
                            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746113102/Expand_down_17_achr9o.png"
                            alt="Expand"
                            onClick={toggleDropdown}
                            className="cursor-pointer w-[15px] h-[16px] md:h-[55px] md:w-[55px] md:-ml-2  -ml-1 object-contain bg-[#F38323] md:px-2 px-[3px] py-[1px] md:py-1 rounded-tr-[4px] rounded-[5px] md:rounded-tr-[5px] rounded-br-[4px] md:rounded-br-[5px]"
                        />
                        {/* Dropdown Menu */}
                        {isOpen && (
                            <div className="absolute top-full right-0 mt-1 py-2 flex justify-center items-center bg-white border border-gray-400 rounded shadow-md z-10 text-[5px] md:text-[18px] w-[60px] md:w-[300px] md:h-[300px]">
                                <div>
                                    <h1 className="md:text-[20px] text-[6px] md:px-2 font-bold md:mb-5">DUE DILIGENCE</h1>
                                    {options.map((option, idx) => (
                                        <div key={idx}>
                                            <p className="px-2 py-1 md:py-2 hover:bg-gray-100 cursor-pointer">{option}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                    <p className="md:text-[16px] text-[4px] font-light md:mb-3 mt-1">Enter Registration number</p>
                </div>
            </div>

            <EnterPriseDevelopment/>
            <div className="flex justify-end md:mt-3 mt-4">
        <button
          className="flex items-center md:gap-2 gap-2  hover:bg-[#0f1f1a] text-black hover:text-white  md:py-3 py-1 rounded-md text-[6px] md:text-lg font-normal italic transition"
        >
          Save
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
            alt="Save Icon"
            className="md:w-11 md:h-11 h-3 w-3"
          />
        </button>
      </div>
      {/* Register Button */}
      <button className="w-full bg-[#03897B] flex justify-center md:mt-3  border-b-[3px] md:py-2 py-1 border-[#FDBD26] text-center md:h-[74px] h-[20px] text-white md:text-[36px] text-[6px] font-bold rounded-md">
      Assessment
      </button>
         {/* Buttons */}
         <div className="flex md:gap-4 gap-1  justify-end md:mt-7 mt-2 md:mb-10 mb-5">
        {/* Edit Button */}
        <div>
        <button className="flex items-center justify-between md:w-[230px] w-[100px] md:h-[61px] h-[20px] bg-[#03897B] text-white md:text-[14px] text-[6px] font-bold rounded-[10px] md:px-8 px-4 ">
          <span>EDIT</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690463/Edit_fill_llaa3q.png"
            alt="Edit Icon"
            className="md:w-[35px] h-2  md:h-[38px] w-2 "
          />
        </button>
        <p className='md:text-[14px] text-[6px] md:mt-4  mt-1 font-normal md:px-1 '>
        Edit registration form
        </p>
        </div>


        {/* Save Button */}
    <div>
    <button className="flex items-center justify-between w-[100px] md:w-[230px] h-[20px] md:h-[61px] bg-[#03897B] text-white md:text-[14px]  text-[6px] font-bold  rounded-[10px] px-4">
          <span>SAVE</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690487/Arhive_load_duotone_line_1_hbsukd.png"
            alt="Save Icon"
            className="md:w-[35px] h-2  md:h-[38px] w-2 "
          />
        </button>
        <p className='md:text-[14px]  text-[6px] md:mt-4 mt-1 font-normal md:px-1 '>
        Save registration 
        </p>
    </div>
    <div>
    <button className="flex items-center justify-between w-[100px] md:w-[230px] h-[20px] md:h-[61px] bg-[#03897B] text-white md:text-[14px]  text-[6px] font-bold  rounded-[10px] px-4">
          <span>SEND</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746037449/Send_hor_fill_lfkysb.png"
            alt="Save Icon"
            className="md:w-[35px] h-2  md:h-[38px] w-2 "
          />
        </button>
        <p className='md:text-[14px]  text-[6px] md:mt-4 mt-1 font-normal md:px-1 '>
        Send Due diligence form
        </p>
    </div>
      </div>
        </div>
    )
}

export default TraningCourse